module.exports = __webpack_public_path__ + "static/media/round-log.ef07b700.svg";